import { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Features from "../components/Features";
import ProductDisplay from "../components/ProductDisplay";
import BobShowcase from "../components/BobShowcase";
import ComingSoon from "../components/ComingSoon";
import CustomDev from "../components/CustomDev";
import FAQ from "../components/FAQ";
import ContactCTA from "../components/ContactCTA";
import Footer from "../components/Footer";
import { ScrollProgressBar } from "../components/motion";
import { homeContent, HomeLang } from "../data/homeContent";

// Note: Organization / WebSite / SoftwareApplication / FAQPage structured
// data (schema.org JSON-LD) for SEO + GEO lives statically in
// public/index.html rather than being injected here via Helmet — most AI
// answer-engine crawlers (GPTBot, CCBot, PerplexityBot, ...) fetch raw HTML
// without executing JavaScript, so client-side-only structured data would
// be invisible to them. That static markup always describes the Hungarian
// version, since that's what a non-JS crawler receives at this URL — same
// trade-off as /bob (see BobPage.tsx). Keep public/index.html and the `hu`
// half of src/data/homeContent.ts in sync when the copy changes.
const HomePage = () => {
  const [lang, setLang] = useState<HomeLang>("hu");
  const content = homeContent[lang];

  return (
    <>
      <Helmet>
        <html lang={lang} />
        <title>{content.meta.title}</title>
        <meta name="description" content={content.meta.description} />
      </Helmet>
      <ScrollProgressBar />
      <Header nav={content.nav} lang={lang} onLangChange={setLang} />
      <main>
        <Hero hero={content.hero} />
        <Features about={content.about} />
        <ProductDisplay wobble={content.wobble} />
        <BobShowcase bob={content.bob} />
        <ComingSoon rosa={content.rosa} />
        <CustomDev customDev={content.customDev} />
        <FAQ faq={content.faq} />
        <ContactCTA contactCTA={content.contactCTA} />
      </main>
      <Footer copyright={content.footer.copyright} />
    </>
  );
};

export default HomePage;
